module.exports = __webpack_public_path__ + "static/img/construct1.65864fbe.png";